// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/landing.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BackgroundContainer.css */
.landing_container {
    position: relative;
    height: 500px;
  }
  
  
.landing_background-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Replace 'your-background-image.jpg' with the actual image file path */
  background-size: cover;
  background-position: center;
  height: 500px;
  position: relative;
 

}

.landing_background-overlay {
  background-color: rgba(0, 0, 0, 0.5); /* Adjust the last value (0.3) to control the transparency */
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  
}
  .landing_content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #fff;
    z-index: 0;
  }
  .landing_content h1 {
    font-size: 2rem; /* Default font size for larger screens */
  
    @media (max-width: 768px) {
      font-size: 1.5rem; /* Adjust font size for screens smaller than 768px */
    }
  
    @media (max-width: 576px) {
      font-size: 1.2rem; /* Further adjust font size for screens smaller than 576px */
    }
  }
  h1 {
    font-size: 3rem;
    margin-bottom: 30px;
  }
  
  .buttons {
    display: flex;
    justify-content: center;
  }
  
  button {
   
    font-size: 1.2rem;
    padding:15px;
    
    border: none;
    border-radius: 5px;
    cursor: pointer;
    background-color: #4285f4; /* Google blue color, change as needed */
    color: #fff;
  }
  
  button:hover {
    background-color: #3367d6;
  }
  
  .login-button {
    background-color: #4285f4;
  }
  
  .register-button {
    background-color: #34a853; /* Google green color, change as needed */
  }
  

  .featured-handymen {
    background-color: #f8f9fa;
    padding: 10px ;
  }
  
  .featured-handymen .card {
    transition: all 0.3s ease;
  }
  
  .featured-handymen .card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .featured-handymen .card-title {
    font-size: 1.2rem;
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/components/landing_page/BackgroundContainer.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,aAAa;EACf;;;AAGF;EACE,yDAAkD,EAAE,wEAAwE;EAC5H,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;;;AAGpB;;AAEA;EACE,oCAAoC,EAAE,4DAA4D;EAClG,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;;AAEZ;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;EACA;IACE,eAAe,EAAE,yCAAyC;;IAE1D;MACE,iBAAiB,EAAE,oDAAoD;IACzE;;IAEA;MACE,iBAAiB,EAAE,4DAA4D;IACjF;EACF;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;;IAEE,iBAAiB;IACjB,YAAY;;IAEZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB,EAAE,wCAAwC;IACnE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB,EAAE,yCAAyC;EACtE;;;EAGA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB","sourcesContent":["/* BackgroundContainer.css */\r\n.landing_container {\r\n    position: relative;\r\n    height: 500px;\r\n  }\r\n  \r\n  \r\n.landing_background-image {\r\n  background-image: url('../../assets/landing.webp'); /* Replace 'your-background-image.jpg' with the actual image file path */\r\n  background-size: cover;\r\n  background-position: center;\r\n  height: 500px;\r\n  position: relative;\r\n \r\n\r\n}\r\n\r\n.landing_background-overlay {\r\n  background-color: rgba(0, 0, 0, 0.5); /* Adjust the last value (0.3) to control the transparency */\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 0;\r\n  \r\n}\r\n  .landing_content {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n    color: #fff;\r\n    z-index: 0;\r\n  }\r\n  .landing_content h1 {\r\n    font-size: 2rem; /* Default font size for larger screens */\r\n  \r\n    @media (max-width: 768px) {\r\n      font-size: 1.5rem; /* Adjust font size for screens smaller than 768px */\r\n    }\r\n  \r\n    @media (max-width: 576px) {\r\n      font-size: 1.2rem; /* Further adjust font size for screens smaller than 576px */\r\n    }\r\n  }\r\n  h1 {\r\n    font-size: 3rem;\r\n    margin-bottom: 30px;\r\n  }\r\n  \r\n  .buttons {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  button {\r\n   \r\n    font-size: 1.2rem;\r\n    padding:15px;\r\n    \r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    background-color: #4285f4; /* Google blue color, change as needed */\r\n    color: #fff;\r\n  }\r\n  \r\n  button:hover {\r\n    background-color: #3367d6;\r\n  }\r\n  \r\n  .login-button {\r\n    background-color: #4285f4;\r\n  }\r\n  \r\n  .register-button {\r\n    background-color: #34a853; /* Google green color, change as needed */\r\n  }\r\n  \r\n\r\n  .featured-handymen {\r\n    background-color: #f8f9fa;\r\n    padding: 10px ;\r\n  }\r\n  \r\n  .featured-handymen .card {\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .featured-handymen .card:hover {\r\n    transform: translateY(-5px);\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .featured-handymen .card-title {\r\n    font-size: 1.2rem;\r\n    font-weight: bold;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
